var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewsIcon = function SvgNewsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "newsIcon_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 65.2 65.2"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".newsIcon_svg__cls-1,.newsIcon_svg__cls-2{fill:none;stroke:#12263f;stroke-miterlimit:10}.newsIcon_svg__cls-2{stroke-linecap:square}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.79,
    height: 29.47,
    x: 12.7,
    y: 17.86,
    className: "newsIcon_svg__cls-1",
    rx: 1.47
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6 20.39v24.42",
    className: "newsIcon_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.08 23.95h11.78M37.08 29.72h11.78M37.08 35.48h11.78M37.08 41.25h11.78",
    className: "newsIcon_svg__cls-2"
  })));
};
export default SvgNewsIcon;